import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { ModalComponent, NotificationsService } from '@geekbears/ngx-gb-ui-kit';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { map, Observable, Subject, takeUntil, tap } from 'rxjs';

import {
  deleteCardFailureAction,
  deleteCardSuccessAction,
  MembershipActions,
  cancelMembershipLoadingSelector,
  deleteCardLoadingSelector,
} from '@modules/company-manager/membership/application';
import { Cards } from '@modules/company-manager/membership/domain';

@Component({
  selector: 'app-membership-modals',
  templateUrl: './membership-modals.modal.html',
  styleUrls: ['./membership-modals.modal.scss'],
})
export class MembershipModals
  extends ModalComponent
  implements OnInit, OnDestroy
{
  /**
   * @destroy$ is used to unsubscribe from all subscriptions
   */
  destroy$: Subject<void> = new Subject();
  cardNumber!: number;
  card!: Cards;
  modalType: string = '';
  _user!: string;
  _subscription!: string;
  _company!: string;
  subscription!: any;
  deletePaymentMethodLoading$: Observable<boolean | any>;
  endMembershipLoading$: Observable<boolean | undefined>;
  currentPeriodEnd!: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<MembershipModals>,
    private store$: Store,
    private actions$: Actions,
    private notificationsService: NotificationsService
  ) {
    super();
    if (data) {
      this.modalType = data.type;
      if (data.type === 'cancelMembership') {
        this._subscription = data._subscription;
        this._user = data._user;
        this.subscription = data.subscription;
        this.currentPeriodEnd = data.currentPeriodEnd;
        this._company = data._company;
      } else {
        this.card = data.card;
      }
    }
    this.deletePaymentMethodLoading$ = this.store$.select(
      deleteCardLoadingSelector
    );
    this.endMembershipLoading$ = this.store$.select(
      cancelMembershipLoadingSelector
    );
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngOnInit(): void {
    this.onFailureActions();
    this.actions$
      .pipe(
        ofType(deleteCardSuccessAction),
        map((action) => {
          if (action) {
            this.modalType = 'deleteCardSuccess';
            // this.notificationsService.success('Card successfully Deleted', {
            //   duration: 3000,
            //   icon: 'check-circle',
            // });
            // setTimeout(() => {
            //   this.closeModal();
            // }, 1000);
          }
          return action.response;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  closeModal() {
    this.dialogRef.close();
  }
  deleteCard() {
    const currentUserId = JSON.parse(localStorage.getItem('s_user') || '').id;
    if (currentUserId)
      this.store$.dispatch(
        MembershipActions.deleteCard({
          paymentMethodId: this.card.id,
          userId: currentUserId,
        })
      );
  }

  onFailureActions() {
    this.actions$
      .pipe(
        ofType(deleteCardFailureAction),
        map((action) => {
          return action.failure;
        }),
        getFailureMessageRxOp(),
        tap((errorMessage) => {
          if (errorMessage) {
            this.notificationsService.error(errorMessage, {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
  cardImage(company: string) {
    if (company.toLocaleLowerCase().includes('master'))
      return '/assets/cards/mastercard.png';
    if (company.toLocaleLowerCase().includes('visa'))
      return '/assets/cards/visa.png';
    if (company.toLocaleLowerCase().includes('amex'))
      return '/assets/cards/amex.png';
    if (company.toLocaleLowerCase().includes('cartes'))
      return '/assets/cards/cartes_bancaires.jpeg';
    if (company.toLocaleLowerCase().includes('diners'))
      return '/assets/cards/diners.jpeg';
    if (company.toLocaleLowerCase().includes('discover'))
      return '/assets/cards/discover.png';
    if (company.toLocaleLowerCase().includes('unionpay'))
      return '/assets/cards/UnionPay.png';
    if (company.toLocaleLowerCase().includes('jcb'))
      return '/assets/cards/jcb.png';
    else return 'Unavailable';
  }
  formatDate(date: string) {
    return moment(date).format('MM/DD/YYYY');
  }
  numberFormat(price: any) {
    return new Intl.NumberFormat('en-US').format(price);
  }

  endMembership() {
    this.store$.dispatch(
      MembershipActions.cancelMembership({
        _subscription: this._company,
        _user: this._user,
      })
    );
  }
}
